import { render, staticRenderFns } from "./WorkDetail.vue?vue&type=template&id=22a78916&scoped=true&"
import script from "./WorkDetail.vue?vue&type=script&lang=js&"
export * from "./WorkDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail.vue?vue&type=style&index=0&id=22a78916&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a78916",
  null
  
)

export default component.exports